import React, { useCallback } from 'react'
import { postRequest } from 'src/lib/core/api-client'
import { successToast, errorToast } from 'src/lib/utils/toasters'
import { useUser } from 'src/lib/contexts/UserContext'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { useMerchant } from 'src/lib/contexts/MerchantContext'
import { apiURI } from 'src/lib/utils/constants'
import { Send } from 'react-feather'
import useGTM from 'src/lib/hooks/useGTM'

const ISSUER_ID = process.env.NEXT_PUBLIC_APP_ISSUER_ID ?? ''

const CustomerDataDownload: React.FC<{}> = ({}) => {
  const {
    getters: { merchant },
    actions: { setMerchantData }
  } = useMerchant()
  const { user } = useUser()
  const { setLoaderProperties } = useLoader()
  const { sendGTMTrigger } = useGTM()
  const downloadCustomerData = useCallback(async () => {
    try {
      const payload = {
        name: 'Rewards',
        frequencyType: 'ONCE',
        columns: ['phone', 'balance', 'total_earned', 'total_consumed', 'total_expired'],
        type: 'rewards',
        emails: [user?.email],
        reportDateRange: {
          start: '2025-04-13 18:30',
          end: '2025-04-14 18:30'
        }
      }
      setLoaderProperties({ isLoaderVisible: true, message: 'Requesting customer data download.' })
      await postRequest(`/dashboard/report/scheduler-create`, apiURI.CHECKOUT_NODE, payload)
      sendGTMTrigger('rewards_customer_data_downloaded', 'click')
      successToast(`Export successful. Your report has been sent to ${user?.email}`)
    } catch (e) {
      console.error(e)
      errorToast('Error while downloading file. Please try again.')
    } finally {
      setLoaderProperties({ isLoaderVisible: false })
    }
  }, [user, merchant])

  return (
    <div
      onClick={user?.isDemoUser ? undefined : downloadCustomerData}
      className={`flex items-center justify-between ${
        user?.isDemoUser ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
      }`}
    >
      <p>Export customer data</p>
      <Send size='16' className='font-medium text-[#6E6E6E] stroke-[2.5px]' />
    </div>
  )
}

export default CustomerDataDownload
